import { WORKFLOWS_PAGE } from 'constants/pageConsts';
import type { MainPageState } from '.';
import { getWindowDimensions } from 'embed/utils';

const initialState: MainPageState = {
  history: [WORKFLOWS_PAGE],
  imageViewer: {
    alt: '',
    src: '',
  },
  isHelpButtonVisible: true,
  isMobile: false,
  isWidgetVisible: false,
  navigateBackAction: undefined,
  selectedAnswerIndex: -1,
  selectedTab: 0,
  visualViewportOffset: {
    offsetLeft: 0,
    offsetTop: 0,
  },
  windowDimensions: getWindowDimensions(),
};

export default initialState;
